export function StatusPill({ value }: { value: string }): JSX.Element {
  const cls = (value || '').toLowerCase();
  return (
    <span className={`pill ${cls}`}>
      <span className="pdot" />{value}
    </span>
  );
}

// Same shape, semantically distinct — used for generation status (Succeeded/Failed/Running).
export function GenStatusPill({ value }: { value: string }): JSX.Element {
  const cls = (value || '').toLowerCase();
  return (
    <span className={`pill ${cls}`}>
      <span className="pdot" />{value}
    </span>
  );
}

import type { SentStatus } from '../types';

const SENT_PILL: Record<SentStatus, { cls: string; label: string }> = {
  unsent: { cls: 'unsent', label: 'Unsent' },
  sent: { cls: 'sent', label: 'Sent' },
  sent_changed: { cls: 'changed', label: 'Sent — changed' },
};

/** Sent-to-finance badge; 'sent_changed' = differs from what Finance last received. */
export function SentPill({ value }: { value: SentStatus | null | undefined }): JSX.Element {
  const { cls, label } = SENT_PILL[value ?? 'unsent'];
  return (
    <span className={`pill ${cls}`}>
      <span className="pdot" />{label}
    </span>
  );
}
